import { useState, Fragment, useEffect } from "react";
import styles from "./Transactions.module.scss";
import PaginationTable from "../../components/table/pagination-table";
import { ColumnTransactions, TransactionsData, } from "../../types/TablesTypes/Transactions";
import StatusView from "../../components/StatusView/StatusView";
import TableHeader from "../../components/TableHeader/TableHeader";
import TransactionsMenu from "../../components/MenuOption/TransactionsMenu/TransactionsMenu";
import transactionsApi from "../../api/transactions";
import useApi from "../../hooks/useApi";
import client from "../../api/client";
import { numberWithCommas } from "../../utils/formatNumber";
import moment from "moment";
import { openLoader, closeLoader, } from "../../redux/actions/loader/loaderActions";
import { useDispatch, useSelector } from "react-redux";
import { ToastErrorStyles, } from "../../constants/toastStyles";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import FilteredUsage from "../../components/filterUsableComponent/FilteredUsage";

const Transactions = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [tableRow, setTableRow] = useState<any[]>();
  const [transactions, setTransactions] = useState<any>();
  const { currency } = useSelector((state) => state.appSettingsReducer);

  //for filtering
  const [dropdown, setDropdown] = useState(false);
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [paymentreference, setPaymentReference] = useState("");
  const [orderreference, setOrderReference] = useState("");
  const [status, setStatus] = useState("Successful");
  const [bearer, setBearer] = useState(false);
  const clearHandler = () => {
    setFromDate("");
    setToDate("");
    setPaymentReference("");
    setOrderReference("");
    setStatus("");
    setDropdown(false);
    setBearer(true);
  };
  const filteredArray = [
    {
      id: 1,
      name: "Status",
      value: status,
      setValue: setStatus,
      selective: [
        { value: "", name: "All" },
        { name: "Initiated" },
        { name: "Awaiting-Confirmation" },
        { name: "Pending" },
        { name: "Successful" },
        { name: "Reversed" },
        { name: "Failed" },
        { name: "Processing" },
      ],
    },
    {
      id: 2,
      name: "Payment Reference",
      value: paymentreference,
      setValue: setPaymentReference,
    },
    {
      id: 3,
      name: "Order Reference",
      value: orderreference,
      setValue: setOrderReference,
    },
  ];
  const getTransactionsApi = useApi(transactionsApi.getTransactions);

  const fetchTransactions = async (isExport = false) => {
    dispatch(openLoader());
    try {
      const { data }: any = await client.get(
        `/subsidiary/dashboard/fetch/orders?currency=${currency}&status=${status}&paymentreference=${paymentreference}&orderreference=${orderreference}&fromdate=${fromDate}&todate=${toDate}&IsExport=${isExport}`
      );
      setTransactions(data?.data);
      dispatch(closeLoader());
      setBearer(false);
      if (isExport) return data?.data?.items ?? []
    } catch (error: any) {
      dispatch(closeLoader());
      if (error?.response?.data?.message === "Please login again") {
        sessionStorage.clear();
        window.location.href = "/";
      } else {
        const message = error?.response?.data?.message;

        dispatch(
          openToastAndSetContent({
            toastContent: message,
            toastStyles: ToastErrorStyles,
          })
        );
      }
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [currency, bearer]);

  const dataTransaction = () => {
    const tempArr: TransactionsData[] = [];
    transactions?.items
      ?.slice(0)
      .reverse()
      .forEach((transaction: any, index: number) => {
        tempArr.push({
          date: moment(transaction?.dateCreated).format("DD-MMM-YYYY hh:mm:ss a"),
          email: transaction?.customerEmail,
          amount: `${transaction.currency} ${numberWithCommas(transaction?.amountFormatted)}`,
          settlementAmount: `${transaction.currency} ${numberWithCommas(
            transaction?.settlementAmount
          )}`,
          payment: transaction?.paymentTypeName,
          reference: transaction?.orderReference,
          status: (
            <StatusView
              status={transaction?.orderStatus}
              green="Successful"
              red="Awaiting-Confirmation"
              orange="Initiated"
            />
          ),
          action: (
            <TransactionsMenu
              currency={transaction.currency}
              transactionId={transaction?.id}
              fetchTransactions={fetchTransactions}
              amount={Number(transaction?.amountFormatted)}
              customerId={transaction?.customerId}
              status={transaction?.orderStatus}
              reference={transaction?.paymentReference}
            />
          ),
        });
      });
    return tempArr;
  };

  useEffect(() => {
    setTableRow(dataTransaction());
  }, [transactions?.items]);

  return (
    <Fragment>
      <TableHeader
        pageName="Transactions"
        dataLength={transactions?.page?.total}
        data={transactions?.items}
        value={value}
        setValue={setValue}
        dropdown={dropdown}
        setDropdown={setDropdown}
        fetchExportDataHandler={async () => await fetchTransactions(true)}
        FilterComponent={
          <>
            <FilteredUsage
              setDropdown={setDropdown}
              setFromDate={setFromDate}
              setToDate={setToDate}
              setBearer={setBearer}
              clearHandler={clearHandler}
              filteredArray={filteredArray}
            />
          </>
        }
      />

      {getTransactionsApi.loading ? (
        <div className={styles.loading} />
      ) : (
        <PaginationTable
          data={tableRow ? tableRow : []}
          value={value}
          columns={ColumnTransactions ? ColumnTransactions : []}
          emptyPlaceHolder="You currently do not have any transactions"
          total={transactions?.page?.total}
        />
      )}
    </Fragment>
  );
};

export default Transactions;
